import { useFormContext } from 'react-hook-form'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface FirstFloaterSettlementDateFieldProps {}

export const FirstFloaterSettlementDateField: React.FC<
  FirstFloaterSettlementDateFieldProps
> = ({}) => {
  const { control, setValue } = useFormContext<{ first_floater_settlement_date: string }>()

  return (
    <FormField
      name="first_floater_settlement_date"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>First Floater Sett Date</FormLabel>
              <FormError />
            </div>
            <DatePicker
              placeholder={'Choose a date'}
              selected={value ? new Date(value) : undefined}
              onSelect={(date) =>
                date &&
                setValue('first_floater_settlement_date', toISO8601(date), {
                  shouldValidate: true,
                })
              }
            />
          </FormItem>
        )
      }}
    />
  )
}
